import { useContext, useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { TableRefreshContext } from '../../context/TableRefreshContext';
import useTable from '../../hooks/useTable';
import { Table } from './Table';
import TableSearchFormField from './TableSearchFormField';

interface ImappingData {
  [key: string]: string;
}

interface ITableComponent {
  mappingData?: ImappingData;
  tableBaseUrl: string;
  tableHeader: string[];
  tableExtraQueryParams?: string;
  cellNavigation?: (...args: any[]) => void;
  rigthRevealComponent?: (...args: any[]) => React.ReactNode;
  tableLabel?: string | React.ReactNode;
  hasQueryString?: boolean;
}

export const TableComponent: React.FC<ITableComponent> = ({
  tableBaseUrl,
  tableHeader,
  tableExtraQueryParams,
  mappingData,
  cellNavigation,
  rigthRevealComponent,
  tableLabel,
  hasQueryString,
}) => {
  const refreshTableContext = useContext(TableRefreshContext);
  const { endPage, tableData, loading, setLoading, fetchTableData } =
    useTable();

  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const itemsPerPage = 10;
    let tblUri = `${tableBaseUrl}${hasQueryString ? '&' : '?'}page=${
      page - 1
    }&size=${itemsPerPage}`;

    const searchQueryString = searchQuery.trim();
    if (searchQueryString !== '') {
      setPage(1);
      console.log('Searching rn');
      tblUri = `${tableBaseUrl}${hasQueryString ? '&' : '?'}page=${
        page - 1
      }&size=${itemsPerPage}&search=${searchQuery}`;
      console.log('tblURi-->', tblUri);
      fetchTableData(tblUri);
    } else {
      if (tableExtraQueryParams) {
        tblUri = tblUri + '&' + tableExtraQueryParams;
      }
      fetchTableData(tblUri);
    }

    // eslint-disable-next-line
  }, [page, searchQuery, refreshTableContext?.refreshTable]);

  return (
    <TableContainer>
      <TableToolBox>
        <TableLabelSection>{tableLabel}</TableLabelSection>
        <SearchSection>
          <TableSearchFormField setSearchQuery={setSearchQuery} />
        </SearchSection>
      </TableToolBox>
      <Table
        showTableLoadingIcon={loading}
        setShowTableLoadingIcon={setLoading}
        rigthRevealComponent={rigthRevealComponent}
        page={page}
        endPage={endPage}
        tData={tableData}
        clickLeft={() => setPage(page === 0 ? page : page - 1)}
        clickRight={() => setPage(endPage > page ? page + 1 : page)}
        tableHeader={tableHeader}
        mappingData={mappingData}
        cellNavigation={cellNavigation}
      />
    </TableContainer>
  );
};

const TableContainer = styled.div`
  display: grid;
  gap: 1.5rem;

  @media screen and (max-width: 480px) {
    overflow-x: auto;
  }
`;

const TableToolBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TableLabelSection = styled.h1`
  font-size: 1.25rem;
  font-weight: 700;
  color: #2c2421;
`;

const SearchSection = styled.div`
  display: flex;
  gap: 1rem;
  margin-left: auto;
`;
